import { createAction } from "redux-actions";

// Profile
export const setModal = createAction("SET_MODAL_TYPE");

export const removeModal = createAction("REMOVE_MODAL_TYPE");
